import { useLocation } from 'react-router-dom';
import React from 'react';
import Header from "./Header";
import Nav from "./Nav";
import Footer from "./Footer";

function ConfirmedBooking() {
  const location = useLocation();
  const { date, time, guests, occasion } = location.state || {}; // Access form data from the state

  return (
    <>
    <Header>
    <Nav />
    </Header>
    <div style={{ display:'flex', border: '2px solid', padding: '20px', height: '400px', margin: '100px', fontFamily: "Karla",
      fontSize: '22px', boxShadow: '5px 10px #888888' }}>
   <div  style={{ padding: '20px',}}>
   <h1>Booking Confirmed!</h1>
    <p>Your reservation has been successfully made.</p>
    <div style={{ marginTop: '20px'}}>
      <p>Date: {date}</p>
      <p>Time: {time}</p>
      <p>Guests: {guests}</p>
      <p>Occasion: {occasion}</p>
    </div>  
   </div>
   <div style={{ borderLeft: '2px solid', paddingLeft: '70px',}}>
    <h3>Inform this barcode at the front <br/>counter. Thank you.</h3>

      {/* REF: https://barcode.tec-it.com/en */}

    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      <img style={{ width: '170px', height:'auto'}}
        src="https://barcode.tec-it.com/barcode.ashx?data=https%3A%2F%2Fgithub.com%2Fshahrilhamzan&code=MobileQRUrl&dpi=130&eclevel=L" alt="Booking QR code"
      />     
    </div>

    </div>
  </div>
   <Footer /></>

    
  );
}

export default ConfirmedBooking;


// import React from 'react';

// function ConfirmedBooking({ date, time, guests, occasion }) {

//  const place_ordered = formData.map(data => 
// <div>  
//  <p>{data.date}</p>
//  <p>{data.time}</p>
//  <p>{data.guests}</p>
//  <p>{data.occasion}</p>

//   </div>
  
//   ); 
  


//   return (
//     <div>
//       <h1>Booking Confirmed!</h1>
//       <p>Your reservation has been successfully made.</p>
//       <div>{place_ordered}</div>      


//     </div>
//   );
// }

// export default ConfirmedBooking;

